import styled from 'styled-components/macro';
import React from 'react';
import useWindowDimensions from "../utils/dimensions";

const VideoPlayer = styled(({ className, src }) => {

    const {width: windowWidth, height: windowHeight} = useWindowDimensions();

    const containerWidth = windowWidth > 900 ? 640 : windowWidth;
    const containerHeight = windowWidth > 900 ? 480 : windowWidth;

    return (
        <div className={className} style={{ position: 'relative', width: containerWidth, height: containerHeight, maxWidth: '100%', backgroundColor: '#000' }}>
            <iframe allowfullscreen allow="fullscreen" style={{width: "100%", height: "100%", borderRadius: '12px'}} src={`https://player.scored.co?url=${src}`} />
        </div>
)})`
  border-radius: 8px;
`;

export default VideoPlayer;